export const emptyPageFactory = () => ({
  page: 0,
  count: 0,
  total: 0,
  content: [],
  fetching: false
});



// WEBPACK FOOTER //
// ./public/resources/factories.js